/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type OralExamQuestionFillKind = 'case' | 'kind' | 'scene' | 'problem' | 'locus' | 'specimen' | null;
